import { render, staticRenderFns } from "./QuoteReviewingDiscountsStateCard.vue?vue&type=template&id=2b28a0be&"
import script from "./QuoteReviewingDiscountsStateCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteReviewingDiscountsStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports